import VueMonthlyPicker from 'vue-monthly-picker';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import upLoad from '@/assets/img/upload_photo3.jpg';
import axios from "axios";
import store from "@/store";
import CONFIG from "@/assets/js/config.js";
import ACCESS_CONTROL from '@/utils/access-control';
import { canManageHistory } from '@/services/PaymentAccessService';
import { required, minValue, maxLength, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "paymentDetail",
  components: {
    MainLayout,
    VueMonthlyPicker,
    Loading,
    flatPickr,
    Select2Multiple,
  },

  data() {
    return {
      paymentData: {},
      paymentInfo: {},
      campusId: store.state.user.campus_id,
      paymentMethodArr: null,
      isLoading: false,
      student_name: '',
      config: CONFIG,
      paymentStatus: null,
      PaymentHistories: [],
      PaymentHistoryStatus: [],
      STATUS: CONFIG.PAYMENT_HISTORY_STATUS_VAL,
      statusBadge: CONFIG.PAYMENT_HISTORY_STATUS_TEXT,
      ParentStatus: CONFIG.PARENT_PAYMENT_STATUS,
      ParentStatusText: CONFIG.PARENT_PAYMENT_STATUS_TEXT,
      PaymentStatus: { ...CONFIG.PAYMENT_STATUS, DRAFT: 4 },
      noDataMsg: CONFIG.NO_DATA_FOUND,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      isEditing: false,
      editId: null,
      submitted: false,
      ssImage: '',
      errors: {},
      historyData: {
        student_payment_id: null,
        amount: '',
        payment_method_id: '',
        receiver: store.state.user.name,
        payment_date: new Date().toISOString().split('T')[0],
        status: CONFIG.PAYMENT_HISTORY_STATUS_VAL.APPROVED,
        remark: '',
        payment_screenshot: null,
      },
      upLoad,
      grandTotalAmt: 0,
      currency_txt: '',
    };
  },

  validations: {
    historyData: {
      amount: { required, minValue: minValue(0) },
      payment_method_id: {
        required: requiredIf(function () {
          return parseInt(this.historyData.status) === this.STATUS.APPROVED;
        }),
        notZero: function (value) {
          if (parseInt(this.historyData.status) !== this.STATUS.APPROVED) return true;
          return value != 0 && value != null && value !== '';
        },
      },
      receiver: { maxLength: maxLength(100) },
      payment_date: {
        required: requiredIf(function () {
          return parseInt(this.historyData.status) === this.STATUS.APPROVED;
        }),
      },
      status: { required },
      remark: { maxLength: maxLength(1000) },
    },
  },

  computed: {
    studentPaymentId() {
      return this.$route.params.invoiceId;
    },

    displayPaymentStatus() {
      const totalPaid = this.totalApprovedAmount;
      let statusKey;

      if (totalPaid === 0) {
        statusKey = this.ParentStatus.NOT_PAID;
      } else if (totalPaid < this.grandTotalAmt) {
        statusKey = this.ParentStatus.PARTIAL_PAID;
      } else {
        statusKey = this.ParentStatus.FULLY_PAID;
      }
      return this.ParentStatusText[statusKey];
    },

    totalApprovedAmount() {
      return this.PaymentHistories.reduce((sum, history) => {
        if (Number(history.status) === this.STATUS.APPROVED) {
          return sum + this.parseHistoryAmount(history);
        }
        return sum;
      }, 0);
    },

    filteredPaymentStatus() {
      return Object.entries(CONFIG.PAYMENT_HISTORY_STATUS_TEXT)
        .filter(([key]) => {
          const statusKey = parseInt(key);

          if (key === '0') return false;
          if (!this.isEditing) {
            return statusKey === this.STATUS.ADMIN_REQUEST || statusKey === this.STATUS.APPROVED;
          }
          const currentRecord = this.PaymentHistories.find(h => h.id === this.editId);
          const originalStatus = currentRecord ? parseInt(currentRecord.status) : null;

          if (originalStatus === this.STATUS.APPROVED || originalStatus === this.STATUS.REJECTED) {
            return statusKey !== this.STATUS.ADMIN_REQUEST;
          }
          return true;
        })
        .map(([key, value]) => ({
          id: key,
          text: value,
        }));
    },
  },

  watch: {
    'historyData.status': function (newVal) {
      const status = parseInt(newVal);
      if (status === this.STATUS.APPROVED) {
        this.historyData.payment_date = new Date().toISOString().split('T')[0];
      } else if (status === this.STATUS.ADMIN_REQUEST) {
        this.historyData.payment_date = null;
        this.historyData.payment_method_id = null;
      } else {
        this.historyData.receiver = this.$store.state.user.name;
      }
    },
  },

  methods: {
    can(module, action) {
      const user = this.$store.state.user;
      if (user?.admin_no === '0001' || user?.role === CONFIG.ROLE.ID.ADMIN) {
        return true;
      }
      const permissions = ACCESS_CONTROL[module]?.[action];
      return permissions ? permissions.includes(user?.role) : false;
    },

    parseHistoryAmount(history) {
      if (history?.amount_raw != null) {
        return Number(history.amount_raw) || 0;
      }
      const raw = String(history?.amount || history?.pay_amount || 0).replace(/,/g, '').split(' ')[0];
      const parsed = parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    getLoggedInUserName() {
      return this.$store.state.user?.name || '';
    },

    canManageHistory(action, history) {
      return canManageHistory(action, history, this.$store.state.user);
    },

    getPaymentMethod() {
      return axios.get('getPaymentMethod')
        .then(res => {
          const defaultSelectOption = [{
            id: 0,
            text: 'Select Payment Method',
          }];
          this.paymentMethodArr = defaultSelectOption.concat(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        }).finally(() => {
            this.isLoading = false;
        });
    },

    getDetail() {
      return axios.get('payment/detail/' + this.$route.params.invoiceId, {
        params: {
          class_id: this.$route.params.classId,
          campus_id: store.state.user.campus_id,
        },
      }).then(res => {
        if (!res.data || !res.data.payment_data) {
          this.$notification.error("This payment does not exist on this campus", {
            timer: 3,
            position: "bottomCenter",
          });
          this.$router.push({ name: "paymentList" });
          return;
        }
        this.paymentData = res.data;
        this.paymentInfo = this.paymentData.payment_data;
        this.student_name = res.data.student_name;
        const statusOption = CONFIG.PAYMENT_STATUSES_OPTIONS.find(
          option => option.id == this.paymentInfo.status
        );
        this.paymentStatus = statusOption ? statusOption.text : '';
        if (this.paymentInfo.grand_total_amt) {
          const parsed = parseFloat(String(this.paymentInfo.grand_total_amt).replace(/,/g, '').split(' ')[0]);
          if (!isNaN(parsed)) {
            this.grandTotalAmt = parsed;
          }
        }
      }).catch(error => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },

    getHistoryList() {
      const studentPaymentId = this.$route.params.invoiceId;
      return axios.get(`student-payment/${studentPaymentId}/payment-history/list`)
        .then((response) => {
          this.PaymentHistories = response.data.histories || [];
          this.currency_txt = response.data.currency_txt || '';
        })
        .catch(error => {
          console.error("Payment History List Api Error:", error);
        }).finally(() => {
            this.isLoading = false;
        });
    },

    fetchGrandTotal() {
      const id = this.$route.params.invoiceId;
      return axios.get(`payment/${id}/grand-total`)
        .then(res => {
          if (res.data && res.data.grand_total != null) {
            this.grandTotalAmt = res.data.grand_total;
          }
        })
        .catch(error => {
          console.error("Grand total api error:", error);
        }).finally(() => {
            this.isLoading = false;
        });
    },

    sendNotification() {
      const msg = "Are you sure you want to send payment notification to student?";
      if (window.confirm(msg)) {
        this.isLoading = true;
        const request = {
          campus_id: this.$store.state.user.campus_id,
          payment_id: this.paymentInfo.id,
        };
        axios.post('payment/send-notification', request)
          .then(res => {
            if (res.data.success == true) {
              this.paymentInfo.notice_status = 1;
              this.$notification.success("Payment Notification Send Successfully", {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }).catch((error) => {
            const errorMessage = error.response?.data?.message || "Failed to send payment notification.";
            this.$notification.error(errorMessage, {
              timer: 3,
              position: "bottomCenter",
            });
            if (error.response && error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
          }).finally(() => {
            this.isLoading = false;
          });
      }
    },

    pdfDownload(studentName, paymentId) {
      this.isLoading = true;
      const request = {
        params: {
          campus_id: this.campusId,
          payment_id: paymentId,
          class_id: this.paymentData.class_id,
        },
        responseType: 'blob',
      };
      axios.get("/payment/pdfDownload/" + this.paymentData.student_id, request)
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          const date = new Date();
          const fileName = `invoice_${studentName}_${date.getFullYear()}${(date.getMonth() + 1) > 9 ? '' : '0'}${date.getMonth() + 1}${(date.getDate()) > 9 ? '' : '0'}${date.getDate()}.pdf`;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        }).finally(() => {
          this.isLoading = false;
        });
    },

    openImage(imagePath) {
      window.open(imagePath, '_blank');
    },

    submitPayment() {
      this.submitted = true;
      this.errors = {};

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;
      const submissionData = {
        ...this.historyData,
        receiver: this.getLoggedInUserName(),
        student_payment_id: this.studentPaymentId,
      };
      const currentStatus = parseInt(submissionData.status);
      if (currentStatus === this.STATUS.ADMIN_REQUEST) {
        submissionData.payment_method_id = null;
        submissionData.payment_date = null;
      }
      const payload = {
        ...submissionData,
        payment_screenshot: this.ssImage,
        image_remove: this.ssImage === '' || this.ssImage === null,
      };

      const url = this.isEditing
        ? `student-payment/${this.studentPaymentId}/payment-history/update/${this.editId}`
        : `student-payment/${this.studentPaymentId}/payment-history/store`;

      axios.post(url, payload)
        .then(res => {
          const isSuccess = res.data && (res.data.success === true || res.data.status === 'success');
          if (isSuccess) {
            this.$notification.success(this.isEditing ? "Payment history updated successfully" : "Payment history added successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.resetForm();
            this.getHistoryList();
            this.fetchGrandTotal();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            this.errors = error.response.data.errors || {};
            const amountError = this.errors.amount && this.errors.amount[0];
            this.$notification.error(amountError || "Validation failed.", {
              timer: 3,
              position: "bottomCenter",
            });
          } else {
            if (error.response && error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            console.error(this.isEditing ? "Payment history update api error:" : "Payment history create api error:", error);
            this.$notification.error("Something went wrong.", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    resetForm() {
      this.isEditing = false;
      this.submitted = false;
      this.editId = null;
      this.historyData = {
        student_payment_id: this.$route.params.invoiceId,
        amount: '',
        payment_method_id: 0,
        receiver: this.getLoggedInUserName(),
        payment_date: new Date().toISOString().split('T')[0],
        status: this.STATUS.APPROVED,
        remark: '',
      };
      this.ssImage = '';
    },

    removeImg() {
      this.ssImage = '';
      const imageInput = document.getElementById('image');
      if (imageInput) {
        imageInput.value = '';
      }
    },

    imgUpload(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return null;
      }
      if (e.target.files[0].type.includes("image/")) {
        if (e.target.files[0].type == "image/gif") {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
          if (event.target.result.length > 5242880) {
            this.$notification.error(this.imageLargeMsg, {
              timer: 3,
              position: "bottomCenter",
            });
            document.getElementById('image').value = '';
          } else {
            this.ssImage = event.target.result;
            document.getElementById('image').value = '';
          }
        };
        reader.readAsDataURL(files[0]);
      } else {
        this.$notification.error("File not supported!", {
          timer: 3,
          position: "bottomCenter",
        });
        return null;
      }
    },

    editDetailData(history) {
      this.isLoading = true;
      axios.get(`student-payment/${this.studentPaymentId}/payment-history/detail/${history.id}`)
        .then((response) => {
          const isSuccess = response.data && (response.data.success === true || response.data.status === 'success');
          if (isSuccess) {
            const data = response.data.data;
            this.isEditing = true;
            this.editId = data.id;
            this.historyData.amount = Number(data.amount);
            this.historyData.payment_method_id = data.payment_method_id;
            this.historyData.receiver = data.receiver;
            this.historyData.payment_date = data.payment_date;
            this.historyData.status = data.status;
            this.historyData.remark = data.remark;
            this.ssImage = data.payment_screenshot || '';

            const formElement = document.querySelector('.payment-create-form');
            if (formElement) {
              formElement.scrollIntoView({ behavior: 'smooth' });
            }
          }
        })
        .catch(error => {
          console.error("Error fetching history detail:", error);
          this.$notification.error("Could not retrieve record detail", {
            timer: 3,
            position: "bottomCenter",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    deleteHistory(id) {
      if (confirm("Are you sure you want to delete this payment history?")) {
        this.isLoading = true;
        axios.delete(`student-payment/${this.studentPaymentId}/payment-history/delete/${id}`)
          .then(res => {
            if (res.data.success === true || res.data.status === 'success') {
              this.$notification.success("Payment history deleted successfully", {
                timer: 3,
                position: "bottomCenter",
              });
              this.resetForm();
              this.getHistoryList();
              this.fetchGrandTotal();
            } else {
              this.$notification.error(res.data.message || "Failed to delete.");
            }
          })
          .catch(error => {
            console.error("Payment History Api Delete Error:", error);
            this.$notification.error("Failed to delete the record.", {
              timer: 3,
              position: "bottomCenter",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    updateStatus(id, newStatus) {
      const actionText = newStatus === this.STATUS.APPROVED ? "approve" : "reject";

      if (!confirm(`Are you sure you want to ${actionText} this payment history?`)) {
        return;
      }
      if (newStatus === this.STATUS.APPROVED) {
        const historyItem = this.PaymentHistories.find(h => h.id === id);
        const amount = parseFloat(historyItem.amount_raw ?? historyItem.amount ?? historyItem.pay_amount) || 0;

        if ((this.totalApprovedAmount + amount) > this.grandTotalAmt) {
          if (!confirm("Total History Amount will be exceeded Grand Total Amount. Are you sure to approve this history?")) {
            return;
          }
        }
      }
      this.isLoading = true;
      axios.post(`student-payment/${this.studentPaymentId}/payment-history/update-status/${id}`, { status: newStatus })
        .then(res => {
          if (res.data.success === true || res.data.status === 'success') {
            const actionLabel = newStatus === this.STATUS.APPROVED ? "approved" : "rejected";
            this.$notification.success(`Payment history ${actionLabel} successfully`, {
              timer: 3,
              position: "bottomCenter",
            });
            this.getHistoryList();
            this.fetchGrandTotal();
          }
        })
        .catch(error => {
          console.error("Status update error:", error);
          this.$notification.error("Failed to update status");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadReceipt(historyId, studentName) {
      this.isLoading = true;
      const studentPaymentId = this.$route.params.invoiceId;
      axios.get(`student-payment/${studentPaymentId}/payment-history/receipt/${historyId}/pdf-download`, {
        responseType: 'blob',
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          const date = new Date();
          const fileName = `receipt_${studentName}_${date.getFullYear()}${(date.getMonth() + 1) > 9 ? '' : '0'}${date.getMonth() + 1}${(date.getDate()) > 9 ? '' : '0'}${date.getDate()}.pdf`;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.error("Receipt PDF download error:", error);
          this.$notification.error("Failed to download receipt PDF", {
            timer: 3,
            position: "bottomCenter",
          });
        }).finally(() => {
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.historyData.student_payment_id = this.$route.params.invoiceId;
    this.isLoading = true;
    this.PaymentHistoryStatus = Object.entries(CONFIG.PAYMENT_HISTORY_STATUS_TEXT)
      .filter(([key]) => !['0', '2'].includes(key))
      .map(([key, value]) => ({
        id: key,
        text: value,
      }));

    Promise.all([
      this.getPaymentMethod(),
      this.getDetail(),
      this.getHistoryList(),
      this.fetchGrandTotal(),
    ]).finally(() => {
      this.isLoading = false;
    });
  },
};
